<template>

	<div>
		<div class="container">
			<div id="content" class="content">
				<div class="join">
					<!-- 페이지 타이틀 -->
					<h2 class="tit_page page-title">회원정보</h2>

					<form id="frm" @submit.prevent="doSave">
						<div class="join_form">
							<div class="form_row necessary">
								<label for="id" class="lab">아이디<span> •</span></label>
								<input id="id" name="id" type="email" class="inp" placeholder="이메일 형식" v-model="coAccountVO.coEmailId" readonly>
							</div>

							<div class="form_row necessary" v-if="!coAccountVO.isSnsLogin">
								<label class="lab" for="password-check">비밀번호 변경<span> •</span></label>
								<div class="btn-wrap">
									<a href="/mypage/changePassword" class="btn btn-sm btn-primary" style="width: 100%">비밀번호 변경</a>
								</div>
							</div>

							<div class="form_row necessary">
								<label class="lab" for="userName">이름<span> •</span></label>
								<input id="userName" name="userName" type="text" class="inp" placeholder="이름" v-model="coAccountVO.userName" required="required">

							</div>
							<div class="form_row necessary">
								<label class="lab" for="nickName">닉네임<span> •</span></label>

								<input id="nickName" name="nickName" type="text" class="inp" placeholder="닉네임" v-model="coAccountVO.nickName" required="required">

							</div>
							<div class="form_row">
								<label class="lab" for="phoneNo2">휴대전화</label>

								<input id="phoneNo2" name="phoneNo2" type="tel" class="inp" placeholder="‘-’생략하고 입력" v-model="coAccountVO.phone">
							</div>
							<div class="form_row necessary">
								<label class="lab">소속<span v-if="!isTeamCodeNull"> •</span></label>

								<SearchableSelectBox
									ref="searchableSelectBox"
									:placeholder="'부서/직위/직책'"
									:themeColor="'#ffffff'"
									:fontColor="'#3f3f3f'"
									:model="teamCodeModel"
									:valueIfNotFound="''"
									:searchTextLengthConditions4displayingLists="0"
									@getKey="getTeamCode"
									:id="'search-2'"
									:disabled="isTeamCodeNull"
									:spacing="true"
									:withTree="true"
									:additionalClass="'inp'"
								></SearchableSelectBox>
							</div>
						</div>


						<div class="join_terms">
							<div class="terms_all">
								<input type="checkbox" class="inp_check" name="agree-all" id="agree-all" v-model="isAllCheck">
								<label class="lab_check" for="agree-all">전체동의</label>
							</div>
							<ul class="terms_list">
								<li>
									<input class="inp_check" type="checkbox" name="agree1" id="agree1" :true-value="true" :false-value="false" v-model="coAccountVO.isUseTerms">
									<label class="lab_check" for="agree1">(필수) 이용약관 동의</label>
									<a type="button" class="m-l-5" @click="openStaticPage(origin + '/app/statics/termsofservice')">내용보기</a>
								</li>
								<li>
									<input class="inp_check" type="checkbox" name="agree2" id="agree2" :true-value="true" :false-value="false" v-model="coAccountVO.isPrivacyPolicy">
									<label class="lab_check" for="agree2">(필수) 개인정보 수집 및 이용 동의</label>
									<a type="button" class="m-l-5" @click="openStaticPage(origin + '/app/statics/privacypolicy')">내용보기</a>
								</li>
								<li>
									<input class="inp_check" type="checkbox" name="agree3" id="agree3" :true-value="true" :false-value="false" v-model="coAccountVO.isMarketing">
									<label class="lab_check" for="agree3">(선택) 교육 정보 및 이벤트, 혜택 수신 동의 </label>
								</li>
							</ul>
						</div>
						<!-- trems modal -->
						<!--<div class="modal fade" id="terms1">
							<div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
								<div class="modal-content">
									<div class="modal-header px-xl-5 py-4">
										<h3 style="color: var(&#45;&#45;gray800);" class="f-w-500 f-s-18">이용약관 동의</h3>
									</div>
									<div class="modal-body f-s-15" style=" line-height: 1.4;">
										<b>제 1장 총칙</b><br><br>
										<b>제 1조 (목적)</b><br>
										본 약관은 주식회사 상상플렉스(이하 "회사")이 제공하는 상상플렉스 서비스의 이용과 관련하여 "회사"와 "회원" 간의 권리, 의무 및 책임사항, 기타 필요한 사항을 규정함을 목적으로 합니다.
										<br><br>
										<b>제 2조 (정의)</b><br>
										본 약관에서 사용되는 용어의 정의는 다음과 같습니다.<br>
										① “상상플렉스 서비스"(이하 "서비스")라 함은 "크리에이터"로 정의된 이용자들 또는 “회사”에서 PC, 모바일 등의 각종 디지털기기 또는 소프트웨어를 통하여 오디오 콘텐츠를 방송하거나, 또는 다양한 게시물을 게시하고, 그 외 이용자들이 콘텐츠나 게시물을 보면서 댓글 내지 채팅 창 대화 등을 통하여 참여할 수 있는 오디오 콘텐츠 플랫폼 서비스를 말합니다.<br>
										② "회원"이라 함은 "서비스"에 접속하여 본 약관에 따라 "회사"와 이용계약을 체결하고 회사가 제공하는 "서비스"를 이용하는 자를 말합니다.<br>
										③ “비회원이라 함은 회원에 가입하지 않고 상상플렉스서비스를 이용하는 자를 의미합니다.<br>
										④ “이용자”라 함은 “서비스”에 접속하여 이 약관에 따라 “회사”가 제공하는 “서비스”를 이용하는 자를 의미합니다.<br>
										⑤ "닉네임"이라 함은 "회원"이 "서비스"를 이용함에 있어 "서비스" 내 다른 "회원"과 자신의 구별을 위하여 "회원"이 정하고 “회사”가 승인하는 문자와 숫자의 조합을 말합니다.<br>
										⑥ "크리에이터"라 함은 "서비스"에 자신이 제작한 콘텐츠를 게시하거나 방송을 하는 "회원"을 말합니다.<br>
										⑦ “후원”(이하 “후원” 또는 “후원 서비스”)이라 함은 “회원”이 청취 또는 조회하는 콘텐츠를 게시하거나 방송하는 "크리에이터”를 지지하기 위하여 “크리에이터 ”에게 “회원”이 보유중인 “상상플렉스캐시”를 지급하거나, 유료 결제를 통해 일정 금액을 지급하는 것을 말합니다.<br>
										⑧ “유료 콘텐츠”라 함은 “서비스”내의 “크리에이터” 또는 “회사”가 등록한 콘텐츠 중 “회원”이 유료 결제 또는 “캐시”를 지불하여 구매한 후 이용할 수 있는 콘텐츠를 말합니다.<br>
										⑨ "상상플렉스캐시"(이하 “캐시”)라 함은 “회원”이 "서비스”내에서 유료 콘텐츠를 이용하거나, “크리에이터"에게 “후원”을 하기 위해 구매하는 인터넷상 결제 수단을 말하며, “캐시” 1개는 현금 1원과 동일한 가치를 지닙니다.<br>
										⑩ “충전”이라 함은 “회원”이 “후원 서비스”, 또는 “유료 콘텐츠”를 이용하기 위해 “회사”가 정한 결제 수단 중 하나를 선택하여 현금을 “캐시”로 전환하는 행위를 말합니다.<br>
										...
									</div>
									<div class="modal-footer">
										<button type="button" data-dismiss="modal" class="btn btn-sm btn-blue">확인</button>
									</div>
								</div>
							</div>
						</div>
						<div class="modal fade" id="terms2">
							<div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
								<div class="modal-content">
									<div class="modal-header px-xl-5 py-4">
										<h3 style="color: var(&#45;&#45;gray800);" class="f-w-500 f-s-18">개인정보 수집 및 이용 동의</h3>
									</div>
									<div class="modal-body f-s-15" style=" line-height: 1.4;">
										<b>제 1장 총칙</b><br><br>
										<b>제 1조 (목적)</b><br>
										본 약관은 주식회사 상상플렉스(이하 "회사")이 제공하는 상상플렉스 서비스의 이용과 관련하여 "회사"와 "회원" 간의 권리, 의무 및 책임사항, 기타 필요한 사항을 규정함을 목적으로 합니다.
										<br><br>
										<b>제 2조 (정의)</b><br>
										본 약관에서 사용되는 용어의 정의는 다음과 같습니다.<br>
										① “상상플렉스 서비스"(이하 "서비스")라 함은 "크리에이터"로 정의된 이용자들 또는 “회사”에서 PC, 모바일 등의 각종 디지털기기 또는 소프트웨어를 통하여 오디오 콘텐츠를 방송하거나, 또는 다양한 게시물을 게시하고, 그 외 이용자들이 콘텐츠나 게시물을 보면서 댓글 내지 채팅 창 대화 등을 통하여 참여할 수 있는 오디오 콘텐츠 플랫폼 서비스를 말합니다.<br>
										② "회원"이라 함은 "서비스"에 접속하여 본 약관에 따라 "회사"와 이용계약을 체결하고 회사가 제공하는 "서비스"를 이용하는 자를 말합니다.<br>
										③ “비회원이라 함은 회원에 가입하지 않고 상상플렉스서비스를 이용하는 자를 의미합니다.<br>
										④ “이용자”라 함은 “서비스”에 접속하여 이 약관에 따라 “회사”가 제공하는 “서비스”를 이용하는 자를 의미합니다.<br>
										⑤ "닉네임"이라 함은 "회원"이 "서비스"를 이용함에 있어 "서비스" 내 다른 "회원"과 자신의 구별을 위하여 "회원"이 정하고 “회사”가 승인하는 문자와 숫자의 조합을 말합니다.<br>
										⑥ "크리에이터"라 함은 "서비스"에 자신이 제작한 콘텐츠를 게시하거나 방송을 하는 "회원"을 말합니다.<br>
										⑦ “후원”(이하 “후원” 또는 “후원 서비스”)이라 함은 “회원”이 청취 또는 조회하는 콘텐츠를 게시하거나 방송하는 "크리에이터”를 지지하기 위하여 “크리에이터 ”에게 “회원”이 보유중인 “상상플렉스캐시”를 지급하거나, 유료 결제를 통해 일정 금액을 지급하는 것을 말합니다.<br>
										⑧ “유료 콘텐츠”라 함은 “서비스”내의 “크리에이터” 또는 “회사”가 등록한 콘텐츠 중 “회원”이 유료 결제 또는 “캐시”를 지불하여 구매한 후 이용할 수 있는 콘텐츠를 말합니다.<br>
										⑨ "상상플렉스캐시"(이하 “캐시”)라 함은 “회원”이 "서비스”내에서 유료 콘텐츠를 이용하거나, “크리에이터"에게 “후원”을 하기 위해 구매하는 인터넷상 결제 수단을 말하며, “캐시” 1개는 현금 1원과 동일한 가치를 지닙니다.<br>
										⑩ “충전”이라 함은 “회원”이 “후원 서비스”, 또는 “유료 콘텐츠”를 이용하기 위해 “회사”가 정한 결제 수단 중 하나를 선택하여 현금을 “캐시”로 전환하는 행위를 말합니다.<br>
										...
									</div>
									<div class="modal-footer">
										<button type="button" data-dismiss="modal" class="btn btn-sm btn-blue">확인</button>
									</div>
								</div>
							</div>
						</div>-->
						<!-- //learning modal -->
						<div class="join_button">
							<button type="submit" class="btn btn-lg btn_join m-r-10">정보변경</button>
							<input type="button" class="btn btn-lg btn-red" value="회원탈퇴" @click="doOutAccount">
						</div>
					</form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import SearchableSelectBox from "@/components/selectors/searchableSelectBox";

export default {
	name: "infoForm",
	components: {SearchableSelectBox},
	props: {},
	data() {


		return {
			coAccountVO: this.getSessionProc(),
			isAllCheck: false,
			origin: location.origin,
			teamCodeModel: [],
			isTeamCodeNull: true,
		}
	},
	async created() {
		await !this.requireLogin(this, false)
		this.getClass();
	},
	mounted() {
		this.getCoAccount()
	},
	methods: {


		getCoAccount() {

			this.$eventBus.$emit("startProgress")
			this.axiosCaller.get(this, this.APIs.CO_ACCOUNT + "/", {
				coCode: this.webUtils.getSubdomain(),
				coEmailId: this.getSessionProc().coEmailId,
			}, res => {
				this.$eventBus.$emit("doneProgress")
				const result = res.data;
				this.coAccountVO = result.coAccountVO;
			})

		},

		doSave(e) {

			console.log(this.coAccountVO)

			e.preventDefault()
			if (!this.coAccountVO.isUseTerms) {
				this.$swal("이용약관 동의 필수선택", "이용약관에 동의하셔야 사이트를 이용할 수 있습니다.", "error")
				return
			}
			if (!this.coAccountVO.isPrivacyPolicy) {
				this.$swal("개인정보 수집 및 이용 동의 필수선택", "개인정보 수집 및 이용 동의 약관에 동의하셔야 사이트를 이용할 수 있습니다.", "error")
				return
			}
			if ( !this.isTeamCodeNull && (this.coAccountVO.teamCode == null || this.coAccountVO.teamCode === "") ) {
				this.$swal("소속 선택", "선택된 소속이 없습니다.", "error")
				return
			}

			delete this.coAccountVO.rateCodeVO

			this.$eventBus.$emit("startProgress")
			this.axiosCaller.patch(this, this.APIs.CO_ACCOUNT + "/", this.coAccountVO, (res) => {

				this.$eventBus.$emit("doneProgress")
				const result = res.data
				if (result.status === "ok") {
					this.swalUtils.gritter("회원정보 변경완료", "다음 로그인시 부터 적용됩니다.", "success", 3000)
						.then(() => {
							this.$session.set("HWSSessions", this.coAccountVO)
							location.href = "/mypage/"
						})
				} else {
					this.$swal(result.status, result.msg, "warning", "확인")
					return false;
				}
			})

		},

		doOutAccount() {
			this.swalUtils.fire("탈퇴하시겠습니까?", "탈퇴 후 자동으로 로그아웃되며,\r\n로그인이 불가능합니다.", "error", true)
				.then((result) => {
					if (result.isConfirmed) {

						delete this.coAccountVO.rateCodeVO
						delete this.coAccountVO.lastLoginDate

						this.axiosCaller.patch(this, this.APIs.CO_ACCOUNT + "/out", this.coAccountVO, (res) => {
							if (res.data.status === "ok") {
								this.swalUtils.gritter("회원탈퇴 완료", "", "success", 3000)
									.then(() => {
										this.doLogout();
									})
							} else {
								this.$swal(res.data.status, result.data.msg, "warning", "확인")
								return false;
							}
						})
					}
				})
		},

		getTeamCode(key) {
			console.log(key)
			this.coAccountVO.teamCode = key
		},

		getClass() {
			this.axiosCaller.get( this, this.APIs.CO_INFO + "/getClassTree/" + this.webUtils.getSubdomain(), {}, (res) => {

				const result = res.data
				if (result.status === "ok") {
					let codeList = result.codeList
					console.log(result.codeList)
					let tempArr = []
					let minimumLevel = Math.min.apply(null, codeList.map(e => e.codeLevel))

					this.isTeamCodeNull = codeList.length === 0

					codeList.forEach(e => {
						tempArr.push({key: e.code, value: e.codeName, space: e.codeLevel - minimumLevel})
					})

					this.teamCodeModel = tempArr

					let accountTeamCode = codeList.filter(e => e.code == this.coAccountVO.teamCode)[0]
					this.$refs.searchableSelectBox.searchText = accountTeamCode != null ? accountTeamCode.codeName : ""
				}
			})
		}

	},
	computed: {
		allow: function () {
			return [[this.coAccountVO.isUseTerms, this.coAccountVO.isPrivacyPolicy, this.coAccountVO.isMarketing], this.isAllCheck]
		}
	},
	watch: {
		allow: function (n, o) {
			if (n[1] === o[1]) {
				this.isAllCheck = this.allow[1] = this.allow[0].every((e, i, a) => e === a[0]) && this.allow[0][0]
				if (this.allow[1]) this.coAccountVO.isUseTerms = this.coAccountVO.isPrivacyPolicy = this.coAccountVO.isMarketing = true
			} else {
				this.coAccountVO.isUseTerms = this.coAccountVO.isPrivacyPolicy = this.coAccountVO.isMarketing = this.allow[1]
			}
		},
	}

}
</script>

<style scoped>

</style>
